export function removeContextDependentIFrames() {
    const iframes = document.body.querySelectorAll("iframe.context-dependent")
    for (let i = 0; i < iframes.length; i++) {
        document.body.removeChild(iframes.item(i))
    }
}
